var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-layout',[_c('v-btn',{staticClass:"mx-auto",attrs:{"size":"large","variant":"flat"},on:{"click":_vm.login}},[_vm._v("ログイン")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }